import { render, staticRenderFns } from "./NavMenuSectionTitle.vue?vue&type=template&id=f0ff47be&scoped=true&"
import script from "./NavMenuSectionTitle.vue?vue&type=script&lang=js&"
export * from "./NavMenuSectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./NavMenuSectionTitle.vue?vue&type=style&index=0&id=f0ff47be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ff47be",
  null
  
)

export default component.exports